import {
  ADS_ANALYTICS_NAMESPACE,
  OTT_ANALYTICS_NAMESPACE,
  SEO_ANALYTICS_NAMESPACE,
  TRUEVIEW_ANALYTICS_NAMESPACE,
} from './shareableReports';

export const LIGHTWEIGHT_FILTERS_NAMESPACES_WHITELIST = [
  ADS_ANALYTICS_NAMESPACE,
  OTT_ANALYTICS_NAMESPACE,
  SEO_ANALYTICS_NAMESPACE,
  TRUEVIEW_ANALYTICS_NAMESPACE,
];

export const TABLE_CONTEXT_SUFFIX = 'table';
export const TIME_SERIES_CONTEXT_SUFFIX = 'time-series';
export const WIDGETS_CONTEXT_SUFFIX = 'widgets';

export const DEFAULT_CONTEXT_USED_FOR_REPORTS_MIGRATION = TABLE_CONTEXT_SUFFIX;
